import { render, staticRenderFns } from "./404.vue?vue&type=template&id=36e74470&lang=pug&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=36e74470&prod&lang=sass&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports